/*
 * SalesAnalytics — /admin/sales
 *
 * Thin page wrapper around <SalesTab />. The rich sales UI now lives inside
 * the Command Center's Sales tab; this route is preserved for direct-URL
 * access and for internal deep-links.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import SalesTab from "../components/analytics/SalesTab";

const GOLD = "#C5A55A";

const RANGES = [
  { value: "7d",  label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "90d", label: "Last 90 days" },
  { value: "1y",  label: "Last year" },
  { value: "total", label: "All time" },
];

export default function SalesAnalytics() {
  const navigate = useNavigate();
  const [range, setRange] = useState("30d");

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white" data-testid="sales-analytics-page">
      <header className="sticky top-0 z-40 bg-[#0a0a0a]/90 backdrop-blur-md border-b border-white/[0.06]">
        <div className="max-w-[1600px] mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <button
              onClick={() => navigate("/admin/analytics?tab=sales")}
              className="p-2 rounded-lg text-white/40 hover:text-white hover:bg-white/10 transition-colors"
              data-testid="back-to-command-center"
            >
              <ArrowLeft className="w-5 h-5" />
            </button>
            <div>
              <h1 className="text-lg font-bold tracking-tight" style={{ color: GOLD }}>
                SALES ANALYTICS
              </h1>
              <p className="text-[11px] text-white/30 hidden sm:block">
                Revenue · Products · Customers · Forecast
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <select
              value={range}
              onChange={(e) => setRange(e.target.value)}
              className="bg-[#111113] border border-white/10 text-white/80 text-sm rounded-lg px-3 py-1.5 focus:outline-none focus:border-[#C5A55A]/50"
              data-testid="sales-range-selector"
            >
              {RANGES.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
            </select>
          </div>
        </div>
      </header>

      <main className="max-w-[1600px] mx-auto px-4 sm:px-6 py-6">
        <SalesTab range={range} />
      </main>
    </div>
  );
}
